export const Envs = {
  // App
  basePath:
    process.env['NEXT_PUBLIC_APP_BASE_PATH'] ??
    process.env['NX_PUBLIC_APP_BASE_PATH'] ??
    '',
  apiEndpoint:
    process.env['NEXT_PUBLIC_API_ENDPOINT'] ??
    process.env['NX_PUBLIC_API_ENDPOINT'] ??
    '',

  // Auth
  keycloakId:
    process.env['NEXT_PUBLIC_KEYCLOAK_ID'] ??
    process.env['NX_PUBLIC_KEYCLOAK_ID'] ??
    '',

  // Analytics
  gtmId:
    process.env['NX_PUBLIC_GTM_ID'] ?? process.env['NEXT_PUBLIC_GTM_ID'] ?? '',

  // Build
  version:
    process.env['NX_PUBLIC_BUILD_VERSION'] ??
    process.env['NEXT_PUBLIC_BUILD_VERSION'] ??
    '',

  // Security
  basicAuth:
    process.env['NX_PUBLIC_BASIC_AUTH'] ??
    process.env['NEXT_PUBLIC_BASIC_AUTH'] ??
    '',

  // Development
  hideDevTools:
    (
      process.env['NX_PUBLIC_HIDE_DEV_TOOLS'] ??
      process.env['NEXT_PUBLIC_HIDE_DEV_TOOLS'] ??
      'false'
    ).toLowerCase() === 'true',
};
